import {create} from 'zustand';
import {QUESTIONIDS} from '../types/question';
import {QuestionId} from './navigation';
import {SurveyResponse} from '../types/surveyResponse';

interface ResultStore {
  result: SurveyResponse;
  updateQuestion: (questionData: Data) => void;
}

type Data =
  | {
      id: typeof QUESTIONIDS.questionOneName;
      value: SurveyResponse[typeof QUESTIONIDS.questionOneName];
    }
  | {
      id: typeof QUESTIONIDS.questionTwoYourVehicle;
      value: SurveyResponse[typeof QUESTIONIDS.questionTwoYourVehicle];
    }
  | {
      id: QuestionId;
      value: string | string[];
    }
  | {
      id:
        | typeof QUESTIONIDS.questionFourPassengers
        | typeof QUESTIONIDS.questionTwelveTravelDistance;
      value: SurveyResponse[typeof QUESTIONIDS.questionFourPassengers];
    }
  | {
      id: typeof QUESTIONIDS.questionSevenVehicleFeatures;
      value: SurveyResponse[typeof QUESTIONIDS.questionSevenVehicleFeatures];
    }
  | {
      id: typeof QUESTIONIDS.questionThirteenForm;
      value: SurveyResponse[typeof QUESTIONIDS.questionThirteenForm];
    }
  | {
      id: typeof QUESTIONIDS.questionEightAddress;
      value: SurveyResponse[typeof QUESTIONIDS.questionEightAddress];
    };

export const useResultStore = create<ResultStore>((set) => ({
  updateQuestion: (questionData: Data) => {
    set((state) => {
      const questionId = questionData.id;
      const currentResult = {...state.result};
      return {
        result: {
          ...currentResult,
          [questionId]: questionData.value,
        },
      };
    });
  },
  result: {} as SurveyResponse,
}));
